const { createContext } = require("react");

export const CurrentUserContext = createContext();
export const EnvContext = createContext({});
export const CurrentComponentIndexContext = createContext();
export const CurrentMessageViewContext = createContext();
export const NeutralPmContext = createContext();